export interface ICommand { }

export class CreateResourceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Resources.Commands.CreateResourceCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Unit: string
	ExpenseClassification: any
	CostPerUnit: number | null

	constructor (workspaceId: number, strategyId: string, id: string, name: string, unit: string, expenseClassification: any, costPerUnit: number | null)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Unit = unit
		this.ExpenseClassification = expenseClassification
		this.CostPerUnit = costPerUnit
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Resources.Commands.CreateResourceCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteResourceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Resources.Commands.DeleteResourceCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string

	constructor (workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Resources.Commands.DeleteResourceCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateResourceCapacitiesCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Resources.Commands.UpdateResourceCapacitiesCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Entries: any

	constructor (workspaceId: number, strategyId: string, id: string, entries: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Entries = entries
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Resources.Commands.UpdateResourceCapacitiesCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateResourceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Resources.Commands.UpdateResourceCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Unit: string
	ExpenseClassification: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, unit: string, expenseClassification: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Unit = unit
		this.ExpenseClassification = expenseClassification
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Resources.Commands.UpdateResourceCommandV1, TCh.Domain.Quest'
	}

}

